function Lesotho({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1506)">
  <path d="M0 15.9998C0 18.493 0.570438 20.8528 1.58763 22.9563L16 23.652L30.4124 22.9564C31.4296 20.8528 32 18.493 32 15.9998C32 13.5067 31.4296 11.1468 30.4124 9.04334L16 8.34766L1.58763 9.04328C0.570438 11.1468 0 13.5067 0 15.9998H0Z" fill="#F0F0F0"/>
  <path d="M16 31.9996C22.3433 31.9996 27.8244 28.308 30.4124 22.9561H1.58765C4.17565 28.308 9.65664 31.9996 16 31.9996Z" fill="#6DA544"/>
  <path d="M16 0C9.65664 0 4.17565 3.69156 1.58765 9.0435H30.4123C27.8244 3.69156 22.3433 0 16 0Z" fill="#0052B4"/>
  <path d="M17.0435 15.6522V11.8262H14.9565V15.6522L12.4359 18.1729C13.169 19.3729 14.4909 20.174 16 20.174C17.5092 20.174 18.831 19.3729 19.5642 18.1729L17.0435 15.6522Z" fill="black"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Lesotho;
